import { render, staticRenderFns } from "./compnayVault.vue?vue&type=template&id=17373d16"
import script from "./compnayVault.vue?vue&type=script&lang=js"
export * from "./compnayVault.vue?vue&type=script&lang=js"
import style0 from "./compnayVault.vue?vue&type=style&index=0&id=17373d16&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports